exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ck-informations dt{margin-bottom:2px}.ck-informations dd{margin-left:0;min-height:20px}.ck-informations{background:#f9f9f9;padding:10px 15px;border-radius:4px;margin:0;margin-bottom:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49b9ac09","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/visual/ck-informations.vue
// module id = 413
// module chunks = 0